export const TITLE_SUCCESS = "Gelukt";
export const TITLE_WARNING = "Waarschuwing";
export const TITLE_ERROR = "Fout";
export const TITLE_INFO = "Info";

export const MESSAGE_VALIDATION_ERRORS = "Er zijn validatiefouten.";
export const MESSAGE_VALIDATION_ERRORS_SAVED = "Er zijn nog validatiefouten die moeten opgelost zijn vooraleer je het dossier kunt indienen";
export const MESSAGE_NOT_SAVED_CONCURRENCY_EXCEPTION = "Dit onderdeel van je dossier werd reeds elders of door iemand anders aangepast! Gelieve je browser te herladen (CTRL-F5) of volledig te sluiten, om op de meest recente aanpassingen van je dossier verder te werken.";
export const MESSAGE_FILE_EXCEPTION = "Verwerken van bestand is mislukt";
export const MESSAGE_SAVED = "Opgeslagen.";


export const MESSAGE_NO_GEOCOORDINATEN = "Er zijn geen coördinaten gevonden, gelieve zelf de coördinaten in te vullen";
export const MESSAGE_NO_GEOCOORDINATEN2 = "Er zijn geen coördinaten gevonden, gelieve deze te wijzigen op de kaart";
export const MESSAGE_RAPPORT_GENEREREN = "Uw financiële rapporten worden gegenereerd";
export const MESSAGE_RAPPORT_SIMULATIE_GENEREREN = "Uw simulatierapport wordt gegenereerd";
export const MESSAGE_PDF_GENEREREN = "Uw PDF wordt gegenereerd";
export const MESSAGE_VALIDATION_ERRORS_SAVED_SIMULATIE = "Er zijn nog validatiefouten die moeten opgelost zijn vooraleer je de simulatie kunt starten";
